/* ============================================================
   ILS — PDP reviews-widget summary patcher (TASK-1978).
   Section: theme/sections/custom-main-product.liquid

   Reads window.ILS_REVIEWS_HOME = { apiBase } and replaces the
   per-product Liquid fallback inside [data-ils-pdp-rev-summary]
   with the OVERALL store numbers from
   GET {apiBase}/api/reviews/summary
     { average, count_total_raw, breakdown: { "5":{percent}, ... } }

   On fetch error / empty payload the Liquid fallback is preserved
   so the block is never blank.
   ============================================================ */
(function () {
  'use strict';

  /* Star SVG path — identical to custom-product-page.js so the
     re-rendered stars look the same as the rest of the PDP. */
  var STAR_PATH = 'M12 2.6c.55 0 1.04.33 1.27.83l2.3 4.96 5.43.7c.55.07.99.45 1.16.97.16.51-.01 1.07-.42 1.43l-4.02 3.52 1.06 5.4c.1.54-.12 1.08-.57 1.4-.45.31-1.04.34-1.52.07L12 18.86l-4.69 2.61c-.48.27-1.07.24-1.52-.07-.45-.32-.67-.86-.57-1.4l1.06-5.4-4.02-3.52c-.41-.36-.58-.92-.42-1.43.17-.52.61-.9 1.16-.97l5.43-.7 2.3-4.96c.23-.5.72-.83 1.27-.83z';

  function starSvg(state) {
    if (state === 'full') return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR_PATH + '"/></svg>';
    if (state === 'dim')  return '<svg viewBox="0 0 24 24" class="dim" aria-hidden="true"><path d="' + STAR_PATH + '"/></svg>';
    var gid = 'ilshgp' + Math.random().toString(36).slice(2, 8);
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<defs><linearGradient id="' + gid + '"><stop offset="50%" stop-color="var(--ils-star)"/><stop offset="50%" stop-color="var(--ils-star-dim)"/></linearGradient></defs>' +
      '<path d="' + STAR_PATH + '" fill="url(#' + gid + ')"/></svg>';
  }

  function renderStarsFor(el, rate) {
    rate = parseFloat(rate) || 0;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      if (rate >= i)            html += starSvg('full');
      else if (rate >= i - 0.5) html += starSvg('half');
      else                      html += starSvg('dim');
    }
    el.innerHTML = html;
    el.dataset.ilsStarsBuilt = '1';
  }

  /* "4.83" -> "4,83" (two decimals, comma decimal — matches reviews page). */
  function formatAverage(n) {
    var v = parseFloat(n);
    if (!isFinite(v)) return '';
    return v.toFixed(2).replace('.', ',');
  }

  /* 2718 -> "2.718" (EU thousands dot). */
  function formatThousandsDot(n) {
    var v = parseInt(n, 10);
    if (!isFinite(v)) return '';
    return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function init() {
    var root = document.querySelector('[data-ils-pdp-rev-summary]');
    if (!root) return;

    var cfg = window.ILS_REVIEWS_HOME || {};
    var apiBase = (typeof cfg.apiBase === 'string' && cfg.apiBase)
      ? cfg.apiBase.replace(/\/+$/, '') : '';
    if (!apiBase) {
      if (window.console && console.warn) {
        console.warn('[ils-pdp-rev-summary] no apiBase configured — keeping Liquid fallback.');
      }
      return;
    }

    fetch(apiBase + '/api/reviews/summary', { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || typeof data !== 'object') return;

        var bigEl   = root.querySelector('[data-rev-big]');
        var starsEl = root.querySelector('[data-rev-stars]');
        var countEl = root.querySelector('[data-rev-count]');

        var avg = (typeof data.average === 'number') ? data.average : parseFloat(data.average);
        if (bigEl && isFinite(avg))   bigEl.textContent   = formatAverage(avg);
        if (starsEl && isFinite(avg)) {
          starsEl.setAttribute('data-rate', String(avg));
          renderStarsFor(starsEl, avg);
        }

        var total = (typeof data.count_total_raw === 'number') ? data.count_total_raw : parseInt(data.count_total_raw, 10);
        if (countEl && isFinite(total)) countEl.textContent = formatThousandsDot(total) + ' ' + (countEl.getAttribute('data-reviews-word') || 'reviews');

        var breakdown = data.breakdown;
        if (breakdown && typeof breakdown === 'object') {
          for (var s = 5; s >= 1; s--) {
            var row = root.querySelector('[data-rev-bar="' + s + '"]');
            if (!row) continue;
            var entry = breakdown[String(s)];
            if (!entry) continue;
            var pct = (typeof entry.percent === 'number') ? entry.percent : parseFloat(entry.percent);
            if (!isFinite(pct)) continue;
            var fill = row.querySelector('.bar > i');
            var num  = row.querySelector('.num');
            if (fill) fill.style.width = pct + '%';
            if (num)  num.textContent  = Math.round(pct) + '%';
          }
        }
      })
      .catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[ils-pdp-rev-summary] fetch failed — keeping Liquid fallback.', err);
        }
      });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
